/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".totals-border[_ngcontent-%COMP%]{border-top:medium solid}.styled-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{text-align:center}.styled-table-innertable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{background-color:#add8e6}.styled-table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{text-align:center}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/review-request/review-request.component.css.shim.ngstyle.js.pre-build-optimizer.js